module.exports = __webpack_public_path__ + "static/DEV4-381db9d2aff3c3da7ff41ae0f0c05b34.jpg";